import { render, staticRenderFns } from "./AiRuleMindMap.vue?vue&type=template&id=5f6822ee&scoped=true&"
import script from "./AiRuleMindMap.vue?vue&type=script&lang=js&"
export * from "./AiRuleMindMap.vue?vue&type=script&lang=js&"
import style0 from "./AiRuleMindMap.vue?vue&type=style&index=0&id=5f6822ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6822ee",
  null
  
)

export default component.exports